<template>
  <div v-html="privacyText"></div>
  <!-- <div>{{appTheme}}</div> -->
</template>
<script>
export default {
  data() {
    return {
      privacyText: "",
    };
  },
  computed: {
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
  },
  watch: {
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          oauthSDK
            .getPrivacy({bsCode:this.$router.history.current.query.bsCode})
            .then((res) => {
              this.privacyText = res;
            })
            .catch((err) => {
              console.log(err);
              this.defalutToast(err.message);
            });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>